export const readPortalPayrollError = async (error: any): Promise<string> => {
  if (!error?.response) {
    return "No fue posible conectarse con el servicio de procesamiento. Verifica tu conexión e inténtalo nuevamente en unos minutos.";
  }

  const status = Number(error.response.status);
  const data = error.response.data;
  let message = "";
  if (data instanceof Blob) {
    try {
      const body = JSON.parse(await data.text());
      message = typeof body?.message === "string" ? body.message : "";
    } catch (_) {
      message = "";
    }
  } else if (typeof data?.message === "string") {
    message = data.message;
  }

  if (status === 401 || /not an authorized user/i.test(message)) {
    return "Tu sesión no está autorizada para realizar este procesamiento. Vuelve a iniciar sesión o solicita acceso.";
  }
  if (/must send ['\"]?userId/i.test(message)) {
    return "No fue posible identificar al usuario de la sesión. Vuelve a iniciar sesión e inténtalo nuevamente.";
  }
  if (status >= 500) {
    if (/código de seguimiento:/i.test(message)) return message;
    return "Ocurrió un problema interno al procesar la nómina. Inténtalo nuevamente y, si continúa, comunícate con soporte.";
  }
  if (message) return message;
  return "No fue posible procesar la nómina. Revisa el archivo y el match de columnas e inténtalo nuevamente.";
};
